export default {
    'APP_NAME': <>CHOICEPROP-EL<sup>™</sup></>,
    'APP_VERSION': 'Version 1.1',
    'COPYRIGHT': '2024, Choice Hotels International, Inc. All rights reserved.',
    'NBSP': '\xa0',
    'SERVICE_NAME': 'hotelOnboardingUI',
}